import { ObjectDeserializer } from 'object-deserializer';
import {
  PlayerInfo,
} from './interfaces';


export function playerInfoDeserializer(
  o: ObjectDeserializer
): PlayerInfo {
  return {
    cCode: o.required('Ccode').asString,
    avatar: o.optional('Avatar')?.asString,
    nGames: o.optional('NGames')?.asNumber,
    nWon: o.optional('NWon')?.asNumber,
    userId: o.required('UserID').asString,
  };
}